import { PortfolioReturnsTimeSeriesElement } from 'communication/types/portfolioReturns/PortfolioReturnsDataElement';

import omitUndefined from 'utils/omitUndefined';
import {
    mapSessionBoundary,
    SessionBoundaryDataTimeSeriesItem,
} from 'utils/timeseries/TimeSeriesDisableRange';

export interface PortfolioReturnsDataTimeSeriesItem
    extends SessionBoundaryDataTimeSeriesItem {
    /*
     * Number of minutes since epoch
     */
    _i: number;
    /*
     * Dollar value of all Buy portfolio positions
     * (p1Value in Indigo1)
     */
    buyValue?: number;
    /*
     * combineSellsAndShorts=true: Dollar value of all Sell and Short portfolio positions
     * combineSellsAndShorts=false: Dollar value of all Sell portfolio positions
     * (p2Value in Ingido1)
     */
    sellValue?: number;
    /*
     * combineSellsAndShorts=false: Dollar value of all Short portfolio positions
     * (p2Value in Ingido1)
     */
    shortValue?: number;
    /*
     * Dollar price of index1 (if set)
     */
    priceIndex1?: number;
    /*
     * Dollar price of index2 (if set)
     */
    priceIndex2?: number;
}

export function mapToPortfolioReturnsDataTimeSeriesItemFromElement<T>(
    from: PortfolioReturnsTimeSeriesElement<T>
): PortfolioReturnsDataTimeSeriesItem {
    return omitUndefined({
        buyValue: from.p1,
        sellValue: from.p2,
        shortValue: from.p3,
        priceIndex1: from.p4,
        priceIndex2: from.p5,
        ...mapSessionBoundary(from),
    });
}
